module.exports = __webpack_public_path__ + "static/img/so4_7.a65d8f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so4_7.jpg
// module id = iCQJ
// module chunks = 11